import { cssVars } from "@/features/landing/utils/css-vars.ts";

type BarKind = "plan" | "actual" | "done" | "late";

interface Bar {
	kind: BarKind;
	at: string;
	span: string;
}

const ROWS: { name: string; bars: Bar[]; noteAt?: string }[] = [
	{
		name: "Fundações",
		bars: [
			{ kind: "plan", at: "0%", span: "20%" },
			{ kind: "done", at: "0%", span: "22%" },
		],
	},
	{
		name: "Estrutura / Pilares",
		bars: [
			{ kind: "plan", at: "15%", span: "25%" },
			{ kind: "done", at: "18%", span: "25%" },
		],
	},
	{
		name: "Estrutura / Lajes",
		bars: [
			{ kind: "plan", at: "30%", span: "30%" },
			{ kind: "actual", at: "35%", span: "25%" },
			{ kind: "late", at: "60%", span: "3.7%" },
		],
		noteAt: "52%",
	},
	{
		name: "Alvenaria",
		bars: [
			{ kind: "plan", at: "50%", span: "30%" },
			{ kind: "actual", at: "55%", span: "8.7%" },
		],
	},
	{
		name: "Instalações elétricas",
		bars: [{ kind: "plan", at: "65%", span: "25%" }],
	},
	{
		name: "Revestimentos",
		bars: [{ kind: "plan", at: "78%", span: "22%" }],
	},
];

const MONTHS = ["Ago", "Set", "Out"];
// "Today" (28/09) as a fraction of the Aug–Oct timeline.
const TODAY = "63.7%";

function MonthLines() {
	return (
		<span data-slot="gantt-lines" aria-hidden="true">
			{MONTHS.map((month) => (
				<span key={month} />
			))}
		</span>
	);
}

export function GanttPanel() {
	return (
		<figure
			data-slot="panel"
			aria-label="Exemplo de cronograma previsto e realizado"
		>
			<div data-slot="panel-head">
				<b data-slot="panel-title">Cronograma · Torre B</b>
				<span data-slot="pill" data-variant="late">
					1 etapa atrasada
				</span>
			</div>
			<div data-slot="gantt-scroll">
				<div data-slot="gantt" style={cssVars({ "--today": TODAY })}>
					<div />
					<div data-slot="gantt-months">
						{MONTHS.map((month) => (
							<span key={month}>{month}</span>
						))}
						<span data-slot="gantt-today-label">Hoje 28/09</span>
					</div>
					{ROWS.map((row) => (
						<div key={row.name} data-slot="gantt-row">
							<div data-slot="gantt-name">{row.name}</div>
							<div data-slot="gantt-lane">
								<MonthLines />
								{row.bars.map((bar) => (
									<span
										key={`${bar.kind}-${bar.at}`}
										data-slot="gantt-bar"
										data-kind={bar.kind}
										style={cssVars({ "--at": bar.at, "--span": bar.span })}
									/>
								))}
								<span data-slot="gantt-today" aria-hidden="true" />
								{row.noteAt ? (
									<span
										data-slot="gantt-note"
										style={cssVars({ "--at": row.noteAt })}
									>
										!
									</span>
								) : null}
							</div>
						</div>
					))}
				</div>
			</div>
			<div data-slot="legend">
				<span>
					<i data-slot="gantt-swatch" data-kind="plan" />
					Previsto
				</span>
				<span>
					<i data-slot="gantt-swatch" data-kind="actual" />
					Realizado
				</span>
				<span>
					<i data-slot="gantt-swatch" data-kind="done" />
					Concluída
				</span>
				<span>
					<i data-slot="gantt-swatch" data-kind="late" />
					Atraso até hoje
				</span>
			</div>
			<div data-slot="note-card">
				<b>Nota · Estrutura / Lajes · 18/09</b>
				<span>
					Chuva forte suspendeu a concretagem da laje do 6º pavimento por dois
					dias.
				</span>
			</div>
		</figure>
	);
}
